import { render } from "./BlockCard.vue?vue&type=template&id=24a58f87&scoped=true"
import script from "./BlockCard.vue?vue&type=script&lang=js"
export * from "./BlockCard.vue?vue&type=script&lang=js"

import "./BlockCard.vue?vue&type=style&index=0&id=24a58f87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a58f87"]])

export default __exports__